<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-user'></i> VIP Level Withdraw - Settings</h3>
          </b-card-header>
          <b-card-body>
            <b-table v-if="tableShow" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(MinimumWithdraw)="data">
                <span>{{format(data.item.MinimumWithdraw, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(MaximumWithdraw)="data">
                <span>{{format(data.item.MaximumWithdraw, '0,0.00')}}</span>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import cSwitch from '../../../../components/Switch'
  import VueNotifications from 'vue-notifications'
  import numeral from 'numeral'
  import {Events} from '../../../../events.js'
  export default {
    name: 'vip-level-settings-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'MinimumWithdraw', label: 'Minimum Withdraw'},
          {key: 'MaximumWithdraw', label: 'Maximum Withdraw'},
          {key: 'TotalMembers', label: 'Total Members'}
        ],
        tableShow: true,
        currentPage: 1,
        perPage: 30
      }
    },
    components: {
      cSwitch
    },
    methods: {
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      getBadge (status) {
        return status === 1 ? 'success' : 'danger'
      },
      getRowCount (items) {
        return items.length
      },
      getVIPList () {
        this.$http.get(this.API_ENDPOINT + '/payment/withdraw/viplevel/list', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      }
    },
    created () {
      this.getVIPList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevelwithdraw/viplevelsettings/VIPLevelSettingsTable.vue